module.exports = __webpack_public_path__ + "media/images/svg/campaign-18bbbeb1e36aa26faab1b497946e6bf3.svg";